import { RootState } from 'rootReducer';

// @ts-ignore
export const surveyFeatureFlagsSelector = (state: RootState) => state.ui.apps.flags;
